import { Link } from 'react-router-dom';

const serviceItems = [
  {
    icon: 'ri-computer-line',
    title: 'システムエンジニアリングサービス(SES)',
    image:
      '/image/businessServices1.jpg',
    description: [
      '官公庁、金融、流通、通信を始め、様々なシステム開発にて蓄積したノウハウと経験を基に、最適な技術者をご提案いたします。',
      'システムに関する知識・スキルはもちろんのこと、人としても魅力的な人材を揃え、お客様より高い評価をいただいております。',
      'プロジェクトの規模や期間、開発状況にも柔軟に対応いたします。',
    ],
  },
  {
    icon: 'ri-code-s-slash-line',
    title: 'システム開発（受託開発）',
    image:
      '/image/businessServices2.jpg',
    description: [
      'お客様の思い描く目的・目標を実現するためのシステムの開発を、MSKがお手伝いいたします。',
      '業務システムやアプリケーション、各種支援ツールなど、効果を最大化するためのソリューションを目的に合わせてご提供しております。',
    ],
    hasContact: true,
  },
];

const ServiceContent = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="space-y-10">
          {serviceItems.map((item, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl shadow-[0_2px_20px_rgba(137,181,107,0.10)] hover:shadow-[0_8px_32px_rgba(137,181,107,0.16)] transition-all duration-400 overflow-hidden flex flex-col md:flex-row"
            >
              <div
                className={`relative w-full md:w-[360px] h-[240px] md:h-auto shrink-0 overflow-hidden bg-[#F8FBF6] ${
                  index % 2 === 1 ? 'md:order-2' : ''
                }`}
              >
                <img
                  src={item.image}
                  alt={item.title}
                  title={`${item.title} - 株式会社MSK`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className={`flex-1 p-8 flex flex-col justify-center ${index % 2 === 1 ? 'md:order-1' : ''}`}>
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#5DAA68]/10">
                    <i className={`${item.icon} text-lg text-[#5DAA68]`}></i>
                  </div>
                  <h4 className="text-base font-bold text-[#89B56B]">
                    {item.title}
                  </h4>
                </div>
                <div className="space-y-3">
                  {item.description.map((text, i) => (
                    <p key={i} className="text-[13px] text-gray-600 leading-[1.9]">
                      {text}
                    </p>
                  ))}
                </div>
                {item.hasContact && (
                  <p className="mt-5 text-[13px] text-gray-600">
                    ご依頼・ご相談は
                    <Link
                      to="/contact"
                      className="text-[#5DAA68] hover:text-[#3F6844] transition-colors font-medium cursor-pointer"
                    >
                      こちら
                    </Link>
                    からどうぞ。
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceContent;
